import RatingIcons from './RatingIcons.vue'

export default RatingIcons
